export default "__VITE_ASSET__CdtTcw6c__"